import { Component, computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { AppDialog } from '../../../shared/ui/dialog/app-dialog';

@Component({
  selector: 'app-document-reject-dialog',
  standalone: true,
  imports: [FormsModule, ButtonModule, TextareaModule, AppDialog],
  templateUrl: './document-reject-dialog.html',
  styleUrl: './document-reject-dialog.scss'
})
export class DocumentRejectDialogComponent {
  visible = model<boolean>(false);
  text = model<string>('');

  loading = input<boolean>(false);
  placeholder = input<string>('ex : photo illisible, document expiré…');

  confirm = output<void>();
  cancel = output<void>();

  confirmDisabled = computed(() => !this.text().trim() || this.loading());
}
